export default "__VITE_ASSET__DbcHqOPb__"